import React from 'react'
import { translate } from '../../../i18n/i18n'
import type { TDevice } from '../types'
import { getDeviceInstallationHeightLabel } from './getDeviceInstallationHeightLabel'

type BaseNodeDevice = {
  source?: string
  height?: string
  connector?: string
  port?: string
}

export const renderNodeDeviceLabel = (nodeDevice: BaseNodeDevice, allDevices: Record<string, TDevice>) => {
  return (
    <>
      {nodeDevice.source
        ? allDevices[nodeDevice.source]?.name || nodeDevice.source
        : translate.phrases.placeholder('Unknown')}
      <br />
      {nodeDevice.height && (
        <>{getDeviceInstallationHeightLabel(nodeDevice.height)}</>
        // eslint-disable-next-line react/jsx-no-literals
      )}
      &nbsp;&nbsp;•&nbsp;&nbsp;
      {nodeDevice.port?.toUpperCase() || nodeDevice.connector?.toUpperCase()}
    </>
  )
}
